import { moment, companyTz, formatCivilDate } from '@/libs/companyTime'

export const DATE_RANGE_PRESETS = {
  today: 'today',
  yesterday: 'yesterday',
  this_week: 'this_week',
  last_week: 'last_week',
  this_month: 'this_month',
  last_month: 'last_month',
  custom: 'custom',
}

function companyToday() {
  return moment.tz(companyTz()).startOf('day')
}

export function resolveDashboardDateRange(preset, customDateFrom = null, customDateTo = null) {
  const today = companyToday()

  switch (preset) {
    case DATE_RANGE_PRESETS.today:
      return {
        from: today.format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
    case DATE_RANGE_PRESETS.yesterday: {
      const yesterday = today.clone().subtract(1, 'day')
      return {
        from: yesterday.format('YYYY-MM-DD'),
        to: yesterday.format('YYYY-MM-DD'),
      }
    }
    case DATE_RANGE_PRESETS.this_week:
      return {
        from: today.clone().startOf('isoWeek').format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
    case DATE_RANGE_PRESETS.last_week: {
      const lastWeekStart = today.clone().subtract(1, 'week').startOf('isoWeek')
      const lastWeekEnd = lastWeekStart.clone().endOf('isoWeek')
      return {
        from: lastWeekStart.format('YYYY-MM-DD'),
        to: lastWeekEnd.format('YYYY-MM-DD'),
      }
    }
    case DATE_RANGE_PRESETS.this_month:
      return {
        from: today.clone().startOf('month').format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
    case DATE_RANGE_PRESETS.last_month: {
      const lastMonthStart = today.clone().subtract(1, 'month').startOf('month')
      const lastMonthEnd = lastMonthStart.clone().endOf('month')
      return {
        from: lastMonthStart.format('YYYY-MM-DD'),
        to: lastMonthEnd.format('YYYY-MM-DD'),
      }
    }
    case DATE_RANGE_PRESETS.custom:
      return {
        from: customDateFrom,
        to: customDateTo,
      }
    default:
      return {
        from: today.clone().startOf('month').format('YYYY-MM-DD'),
        to: today.format('YYYY-MM-DD'),
      }
  }
}

export function formatDashboardDateRange(dateRange) {
  const { from, to } = dateRange || {}

  if (!from || !to) {
    return 'Select a date range'
  }

  return `${formatCivilDate(from)} - ${formatCivilDate(to)}`
}

export const DASHBOARD_DATE_RANGE_PRESET_OPTIONS = [
  { value: DATE_RANGE_PRESETS.today, text: 'Today' },
  { value: DATE_RANGE_PRESETS.yesterday, text: 'Yesterday' },
  { value: DATE_RANGE_PRESETS.this_week, text: 'This week' },
  { value: DATE_RANGE_PRESETS.last_week, text: 'Last week' },
  { value: DATE_RANGE_PRESETS.this_month, text: 'This month' },
  { value: DATE_RANGE_PRESETS.last_month, text: 'Last month' },
  { value: DATE_RANGE_PRESETS.custom, text: 'Custom interval' },
]
